import React from 'react';

const Privacy : React.FC = () => {
  return(
    <div class="privacy-container">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> 01-05-2025</p>

      <h2>Introduction</h2>
      <p>We are committed to protecting your privacy and ensuring transparency about how your data is collected, used, and stored. This Privacy Policy explains how our software operates and handles your information to provide you with the best credit card recommendations while you shop.</p>

      <h2>Information We Collect</h2>
      <ul>
        <li><strong>Personal Information:</strong>
          <ul>
            <li>If you sign in using Google OAuth, we collect your name and email address.</li>
            <li>We store the names of credit cards you use but do not collect sensitive card information such as card numbers or CVV codes.</li>
          </ul>
        </li>
        <li><strong>Browsing Activity:</strong>
          <ul>
            <li>We track your browsing activity only for recognized websites where we can provide value. This helps us offer personalized recommendations to maximize your rewards and savings.</li>
          </ul>
        </li>
      </ul>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To provide real-time and aggregated credit card recommendations.</li>
        <li>To help you save money and earn more rewards based on your shopping habits.</li>
      </ul>

      <h2>Data Storage and Retention</h2>
      <ul>
        <li>Your data is securely stored on our servers.</li>
        <li>We retain your information for up to one year.</li>
        <li>You can delete your data at any time directly through the Chrome extension.</li>
      </ul>

      <h2>Sharing of Information</h2>
      <p>We do not share your data with third parties.</p>

      <h2>User Controls</h2>
      <ul>
        <li>You can choose to sign in anonymously without providing your name or email.</li>
        <li>While users cannot opt out of data collection due to the nature of the extension's functionality, you have full control to delete your data at any time.</li>
      </ul>

      <h2>Compliance</h2>
      <p>This extension is primarily designed for US-based users and does not currently address specific privacy laws like GDPR or CCPA.</p>

      <h2>Cookies and Financial Information</h2>
      <ul>
        <li>We do not use cookies or similar tracking technologies.</li>
        <li>We do not collect or store sensitive financial information.</li>
      </ul>

      <h2>Security</h2>
      <p>We take the security of your data seriously and implement measures to protect it against unauthorized access, alteration, or disclosure.</p>

      <h2>Changes to this Privacy Policy</h2>
      <p>We may update this Privacy Policy from time to time. Any changes will be communicated through the extension or on our landing page.</p>

      <h2>Contact Us</h2>
      <p>If you have any questions or concerns about this Privacy Policy, please contact us at <a href="mailto:hello@stashr.ai">hello@stashr.ai</a>.</p>
    </div>
  )
}

export default Privacy;
